<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 companies-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div>
        <div class="breadcrumbs-section">
          <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
          <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
          <span class="curr-page  breadcrumbs-section-font">Companies</span>
        </div>
        <div class=" meetings-layout">
          <!-- <div class="meetings ml-0 row mb-3 mb-md-4 justify-content-between">Companies
            <div *ngIf="!isRfidEnabled"><button class="btn btn-primary" (click)="rfidBulkUpload()">RFID Bulk
                Upload</button></div>
          </div> -->
          <div>
            <div class="form-check form-check-inline mr-4">
              <input type="radio" class="form-check-input" id="all" value="all" [(ngModel)]="filterType" name="type"
                checked (change)="displayType($event.target.value)">
              <label for="all" class="form-check-label">All</label>
            </div>
            <div class="form-check form-check-inline mr-4">
              <input type="radio" class="form-check-input" id="active" value="active" [(ngModel)]="filterType"
                name="type" (change)="displayType($event.target.value)">
              <label for="active" class="form-check-label">Active</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="inactive" value="inactive" [(ngModel)]="filterType"
                name="type" (change)="displayType($event.target.value)">
              <label for="inactive" class="form-check-label">Inactive</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <div class="col-12 row borders m-0 p-0 ">
          <div class="search-wrapper width-100">
            <label for="search" class="width-100">
              <img class="image-pos pl-4" src="/assets/images/search.png" alt="search">
              <input class="search-box search-padding placeholder-text width-100" [(ngModel)]="searchText" type="text"
                name="searchText" id="menu-search" placeholder="Type here to search…" (keyup)="searchByText(searchText)"
                (search)="searchByText(searchText)">
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 ml-4 justify-content-between meetings-layout">
        <div class="sub-label row">{{totalCount}} {{text}} companies in the campus</div>
      </div>

      <div class="layout-height pt-3 c2 scroll-position" *ngIf="totalCount > 0">
        <div class="meetings-layout pb-4"
          *ngFor="let team of newTeams | filter:searchText | paginate: { itemsPerPage: 10, currentPage: page,totalItems:totalCount }">
          <div class="row-color">
            <div class="d-flex justify-content-between pt-3 ">
              <div class="col-1 pl-4 pr-0">
                <div class="circle">
                  <div class="circle-name ">{{getName(team?.companyName)}}</div>
                </div>
              </div>
              <div class=" pt-2 pl-4 col-7">
                <span class="meeting-room-name pointer-link" (click)="openCompanyDetail(team)">{{team?.companyName}}

                  <br><span *ngIf="team?.isActive" class="pr-1 meeting-time">
                    <span *ngIf="team?.address">{{team?.address}},</span>{{team?.city}}
                  </span>
                  <span *ngIf="!team?.isActive" class="pr-1 meeting-time">Delisted
                    <!-- <span *ngIf="team?.address?.address">,</span>{{team?.address?.city}} -->
                  </span>
                  <!-- <span class="pr-1 meeting-time" *ngIf="member.delisted">Delisted</span>  -->
                  <!-- <br ><span class="pr-1 meeting-time" *ngIf="!member.delisted">{{team.address.address}},{{team.address.city}}</span>
                                    <span class="pr-1 meeting-time" *ngIf="member.delisted">Delisted</span>  -->
                </span>
              </div>
              <div class="justify-content-end d-flex col-4 mr-5">
                <div class="d-flex justify-content-between">
                  <div (click)="emailClick(team)" class="pt-2 pointer-link"
                    *ngIf="team?.m0100TenantAdmin.length > 0  && team?.isActive">
                    <div class="rectangle-select">
                      <span class="email">Email</span>
                    </div>
                    <span>
                      <img class="image-pos-cross" src="/assets/images/email.png"></span>
                  </div>
                  <div class="pt-2 pointer-link" (click)="feedbackClick(team)"
                    *ngIf="!team?.isActive && team?.m0100TenantAdmin.length > 0">
                    <div class="rectangle-select-feedback">
                      <span class="feedback">Get Feedback</span>
                    </div>
                    <span>
                      <img class="image-pos-cross" src="/assets/images/google-forms.png"></span>
                  </div>
                  <div class=" pl-4 ">
                    <div class="d-flex pt-3">
                      <span class="pr-4 activation ">Activation</span>
                      <label class="switch pl-5 pr-3">
                        <input type="checkbox" [checked]="team?.isActive" [value]="team?.isActive"
                          (change)="toggleActivationSelection(team,$event)"
                          (ngModelChange)="toggleActivationSelection(team,$event)">

                        <!-- <input type="checkbox"  [checked]="member.isActive"  checked value="tableSelected" (change)="toggleActivationSelection($event)" > -->
                        <span class="slider round "></span>
                        <ng-template #contentActivation let-modal class="text-center">
                          <div class="modal-height">
                            <div class="modal-body">
                              <div class="">
                                <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
                                <div class="popup-line"></div>
                              </div>
                            </div>
                            <div class="submit col-12 d-flex justify-content-end ">
                              <div class="pr-3">
                                <button type="button " class="cancel-button pt-3"
                                  (click)="modal.close('Save click');onCancel('activation')"><span
                                    class="cancel">Cancel</span></button>
                              </div>
                              <button type="button " class="add-button"><span class="add"
                                  (click)="updateTenantStatus(team);modal.close('Save click')">{{statusText}}</span></button>

                            </div>
                          </div>
                        </ng-template>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
                <span class="pagination-numbers">10/100</span>

            </div> -->
      <div class="d-flex justify-content-center pagination-section mt-4 mb-5" *ngIf="totalCount > 10">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <!-- <div class="pr-3 ratio-class pt-1" *ngIf="member?.length>=10">10/{{members?.list?.length}}</div> -->
          <!-- <div class="pr-3 ratio-class pt-1">{{team?.length}}/{{newTeams.length}}</div> -->
          <div class="pr-3 ratio-class pt-1">{{page}}/{{displayCount}}</div>
          <!-- <div class="pr-3 ratio-class pt-1">10/{{members?.list?.length}}</div> -->
        </div>
      </div>
      <!-- <ngb-pagination [pageSize] = "25" [collectionSize]="100" [(page)]="page" aria-label="Default pagination"></ngb-pagination> -->
    </div>
  </div>
  <!-- <div *ngIf="emailShow">
        <app-email-members [member]="emailIdlist"></app-email-members>
    </div> -->
</div>